var map = {
	"./qsgc-typesmall1-active.png": 2404,
	"./qsgc-typesmall2-active.png": 9141,
	"./qsgc-typesmall3-active.png": 4790,
	"./qsgc-typesmall4-active.png": 9343,
	"./qsgc-typesmall5-active.png": 5848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1504;